module.exports = __webpack_public_path__ + "static/img/6.4765a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/6.png
// module id = +1Pv
// module chunks = 0